import { XpressVehicleType, getVehicleTypeInfo } from '@/modules/vehicle/engine/VehicleType';

export function initJorneySharing(
	fleetLocationProvider: google.maps.journeySharing.FleetEngineTripLocationProvider,
	mapRef: React.RefObject<HTMLDivElement | null>,
	vehicleType?: XpressVehicleType
) {
	// Configure marker setups to customize pickup and hide destination
	// For trip waypoints, we need to check the waypoint type
	const destinationMarkerSetup = (params: any) => {
		// Hide destination/dropoff marker by returning options with visible: false
		return {
			...params,
			markerOptions: {
				visible: false
			}
		};
	};

	const originMarkerSetup = (params: any) => {
		//	console.log('Origin marker setup called with:', params);

		// Hide the default marker
		return {
			...params,
			markerOptions: {
				visible: false
			}
		};
	};

	// Alternative: Use waypoint marker setup which handles both pickup and dropoff
	const waypointMarkerSetup = (params: any) => {
		// Check waypoint type to determine which marker to customize
		const waypointType = params?.waypointType || params?.type;
		if (waypointType === 'PICKUP_WAYPOINT' || waypointType === 'pickup') {
			// Hide the default marker
			return {
				...params,
				markerOptions: {
					visible: false
				}
			};
		} else if (waypointType === 'DROPOFF_WAYPOINT' || waypointType === 'dropoff') {
			return {
				...params,
				markerOptions: {
					visible: false
				}
			};
		}

		return params;
	};

	const vehicleMarkerSetup = (params: any) => {
		// Hide the default vehicle marker by using an invisible symbol - we'll create our own custom overlay with rotation support. Note, visible: false didn't work.

		return {
			...params,
			markerOptions: {
				icon: {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 0 // Scale of 0 makes it invisible
				}
			}
		};
	};

	// Create the map view with Fleet Engine integration
	const mapView = new google.maps.journeySharing.JourneySharingMapView({
		element: mapRef.current!,
		locationProviders: [fleetLocationProvider],
		locationProvider: null,
		automaticViewportMode: google.maps.journeySharing.AutomaticViewportMode.FIT_ANTICIPATED_ROUTE,
		destinationMarkerSetup: destinationMarkerSetup,
		originMarkerSetup: originMarkerSetup,
		waypointMarkerSetup: waypointMarkerSetup,
		vehicleMarkerSetup: vehicleMarkerSetup,
		/* I have found no other way to satisfy our requirements but hide the google fleet route and draw its parts as required ourselves. For example, when ridingto pick up we need to show only part till the pick up.*/
		anticipatedRoutePolylineSetup: (params) => {
			return {
				//polylineOptions: { ...params.defaultPolylineOptions, strokeColor: '#00FF00' },
				visible: false
			};
		},
		/* TODO[Phase2]:  Hide the google fleet part. When xpress proxy provides taken path draw it.*/
		takenRoutePolylineSetup: (params) => {
			return {
				visible: false
			};
		}
	});
	return mapView;
}
